import { Injectable, inject } from "@angular/core";
import { Action } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";

import { AnimationsService, LocalStorageService } from "@app/core";

import {
  ActionSettingsPersist,
  SETTINGS_KEY,
  SettingsActionTypes
} from "./settings.reducer";

@Injectable()
export class SettingsEffects {
  private actions$ = inject<Actions<Action>>(Actions);
  private localStorageService = inject(LocalStorageService);
  private animationsService = inject(AnimationsService);

  persistSettings$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SettingsActionTypes.PERSIST),
        tap((action: ActionSettingsPersist) => {
          console.log(typeof action);
          const { settings } = action.payload;
          const { pageAnimations, elementsAnimations } = settings;
          this.localStorageService.setItem(SETTINGS_KEY, settings);
          this.animationsService.updateRouteAnimationType(
            pageAnimations,
            elementsAnimations
          );
        })
      ),
    { dispatch: false }
  );
}
